import React, { useEffect, useState } from 'react'
import "./TableBooking.css";
import Header from '../../components/Header';
import useAuth from '../../../customHooks/useAuth';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { baseUrl } from '../../../common/baseUrl';
import PageLoader from '../../components/PageLoader/PageLoader';
import axiosInstance from '../../../axiosInstance/axiosInstance';
import { getCurrentUser } from '../../../common/currentUser';
import { HOTEL_TIMEZONE, toHotelISO } from "../../../common/hotelTime";


export default function TableBooking() {


    const location = useLocation();
    const navigate = useNavigate();

    const bookedRooms = location.state?.bookedRooms || [];
    const userId = localStorage.getItem("user_id");

    const hotelId = location.state?.hotelId || "";
    const bookingId = location.state?.bookingId || "";
    const hotelAddress = location.state?.hotelAddress || "";
    const hotelName = location.state?.hotelName || '';
    const checkInDate = location.state?.checkInDate || "";
    const checkOutDate = location.state?.checkOutDate || "";
    const status = location.state?.status || "";
    const activeTab = location.state?.activeTab || "";
    const booking_code = location.state?.booking_code || "";


    // Refresh Handle
    useAuth();

    // CheckId if present or not else navigate to bookings
    useEffect(()=>{
        const checkId = ()=>{
            if(hotelId==="" || bookingId===""){
                navigate("/bookings");
            }
        }
        checkId();
    },[hotelId,bookingId,navigate])


    // For Number of People
    const [qty,setQty] = useState(1);

    // Get today's and tomorrow's date
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    // Error Handling
    const [errors, setErrors] = useState({});

    // Loader
    const [isLoading,setIsLoading] = useState(false);

    // Form Data
    const [formData,setFormData] = useState({
        people : qty ,
        time : "",
        comment : "",
        serviceDate : ""
    });

    // Validate Field
    const validateField = (field, value) => {
        const newErrors = { ...errors };

        switch(field){
            case "serviceDate":
                if(!value.trim()){
                    newErrors.serviceDate = "Date selection is required";
                }else{
                    newErrors.serviceDate = "";
                }
            break;

            case "time":
                if(!value.trim()){
                    newErrors.time = "Time selection is required";
                }else{
                    newErrors.time = "";
                }
            break;

            // case "comment":
            //     if(!value.trim()){
            //         newErrors.comment = "Comment is required";
            //     }else{
            //         newErrors.comment = "";
            //     }
            // break;

            default:
                break;
        }
        setErrors(newErrors);
    };

    // Validation Form
    const validateForm = () => {
        const validationErrors = {};
    
        // if (!formData.comment.trim()) {
        //     validationErrors.comment = "Comment is required.";
        // }
    
        if (!formData.serviceDate) {
            validationErrors.serviceDate = "Please select a service date.";
        }
    
        if (!formData.time) {
            validationErrors.time = "Please select a time for the cab.";
        }
    
        setErrors(validationErrors);
    
        return Object.keys(validationErrors).length === 0;
    };

    
    // Increase Qty
    const increaseQty = () => {
        const newQty = qty + 1;
        setQty(newQty);
        setFormData((prevState) => ({
            ...prevState,
            people: newQty,
        }));
    }

    // Decrease Qty
    const decreaseQty = () => {
        if (qty > 1) {
            const newQty = qty - 1;
            setQty(newQty);
            setFormData((prevState) => ({
                ...prevState,
                people: newQty,
            }));
        }
    }


    // Format Date
    const formatDate = (date) => {
        return date.toLocaleDateString('en-GB', {
            timeZone: HOTEL_TIMEZONE,
        day: 'numeric',
        month: 'short',
        });
    };

    // OnChange
    const handleChange = (e) => {
        const { name, value } = e.target;
        
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
        validateField(name,value)
    };

    // Function to handle date selection
    const handleDateSelection = (selectedDate) => {
        setFormData((prevState) => ({
        ...prevState,
        serviceDate: selectedDate,
        }));
        validateField("serviceDate",selectedDate)
    };


    // Submit Handler
    const handleSubmit = async()=>{

        try{
            if (!validateForm()) {
                // console.log("FOrm Has Some errors Fix it")
                return;
            }
            
            setIsLoading(true);
            // Combine selected date and time into ISO 8601 format
            // Get current year
            const currentYear = new Date().getFullYear();
            // Combine selected date and time into ISO 8601 format
            const selectedDate = new Date(`${formData.serviceDate} ${currentYear}`); // Add current year
            const [hours, minutes] = formData.time.split(':');

            // Set the time to the selected date
            selectedDate.setHours(hours);
            selectedDate.setMinutes(minutes);
            selectedDate.setSeconds(0);


            // Format function without converting to UTC
            // Get the formatted date-time with specified offset
            const isoDateTimeWithInd = toHotelISO(selectedDate);
            // console.log("Date with Offset: ", isoDateTimeWithInd);

            // Convert to ISO format
            // const isoDateTime = selectedDate.toISOString();
            // console.log("Date : ",isoDateTime);

            const passData = {
                additional_comments: formData.comment,
                preferred_time: isoDateTimeWithInd,
                number_of_people: formData.people
            }



            const currentUser = await getCurrentUser();
 
            function findMatchedRooms(bookedRooms, usersData) {
                const contact = usersData.contact;
                const matchedRooms = bookedRooms.filter((room)=>{
                    // Check if guests are null or an empty array, and skip the room if true
                    if (!room.guests || room.guests.length === 0) {
                        return false; // Skip this room
                    }
                    const matchedGuest = room.guests.find((guest)=>guest.contact===contact);
                    if(matchedGuest) {
                        return true; //
                    }
                    else{
                        return false;
                    }
                });
                return matchedRooms;
            }        

            const usersData = currentUser;  
            const matchedRooms = findMatchedRooms(bookedRooms, usersData);

            if(matchedRooms.length<=0){
                // console.log("Booking is not Present ");
                return;
            }
            // console.log("MAtched Rooms : " + matchedRooms[0].id);
 

            try{
                const response = await axiosInstance.post(`/api/v1/users/${userId}/bookings/${bookingId}/booked-rooms/${matchedRooms[0].id}/guest-requests/post-checkin/restaurant-table-request/`,passData);

                // console.log("Response For Table Booking Response : ",response.data);

                toast.success("Table Booking Request Created Successfully");
                navigate("/bookings",{state : {activeRequests : "requests"}})

            }catch(error){
                toast.error(error?.response?.data?.message || "Some Error Occured");
                console.log(error);
            }
    
            // console.log("Data To Be Submmited : ",passData);
        }catch(error){
            console.log(error)
        }
        finally{
            setIsLoading(false);
        }
    }
 

  return (
    <>
        {
            isLoading && <PageLoader/>
        }
        <div className='tableBooking'>
            <Header title="Book a table at the hotel restaurant"
                hotelName = {hotelName}
                hotelAddress = {hotelAddress}
                checkInDate = {checkInDate}
                checkOutDate = {checkOutDate}
                status = {status}
                activeTab = {activeTab}
                hotelId = {hotelId}
                bookingId = {bookingId}
                movetoHotel = "movetoHotel"
                booking_code = {booking_code}
            />

            {/* Table Fields */}
            <div className="table-data">
                
                {/* Number of Guests */}
                <div className='table-fields'>
                    <div className='table-name'>
                        <h4>Number of Guests</h4>
                    </div>
                    <div className='table-inpGuests'>
                        <div className='qtyButton' onClick={decreaseQty}>-</div>
                        <div className='qty'>{qty}</div>
                        <div className='qtyButton' onClick={increaseQty}>+</div>
                    </div>
                </div>

                {/* Date */}
                <div className='table-fields'>
                    <div className='table-name'>
                        <h4>Date of the booking</h4>
                    </div>

                    <div className='date-selection'>
                        <div
                        className={`date-box ${formData.serviceDate === formatDate(today) ? 'selected' : ''}`}
                        onClick={() => handleDateSelection(formatDate(today))}
                        >
                        {formatDate(today)}  
                        </div>
                        <div
                        className={`date-box ${formData.serviceDate === formatDate(tomorrow) ? 'selected' : ''}`}
                        onClick={() => handleDateSelection(formatDate(tomorrow))}
                        >
                        {formatDate(tomorrow)}  
                        </div>
                    </div>
                    {errors.serviceDate && <span className="error-message">{errors.serviceDate}</span>}
                </div>


                {/* Time */}
                <div className='table-fields'>
                    <div className='table-name'>
                        <h4>When do you want to book a table</h4>
                    </div>
                    <div className='table-inp'>
                        <input type="time" name="time" value={formData.time} onChange={handleChange} 
                        />
                        {errors.time && <span className="error-message">{errors.time}</span>}
                    </div>
                </div>


                {/* Comments */}
                <div className='table-fields'>
                    <div className='table-name'>
                        <h4>Comments</h4>
                    </div>
                    <div className='table-inp'>
                        <textarea name="comment" rows='4' cols="10" value={formData.comment}  onChange={handleChange} ></textarea>
                        {errors.comment && <span className="error-message">{errors.comment}</span>}
                    </div>
                </div>


                {/* Button */}
                <div className='btn'>
                    <button onClick={handleSubmit} disabled={formData.serviceDate==="" || formData.people==="" ||formData.time===""} >Request Table</button>
                </div>
            </div>
        </div>
    </>
  )
}
